import 'url-search-params-polyfill';

export const getRedirectLink = queryString => {
	const urlParams = new URLSearchParams(queryString);
	return urlParams.has('retURL') ? urlParams.get('retURL') : '/';
};

const splitUrl = url => {
	const splitpath = url.split('?');
	const pathname = splitpath[0];
	const search = splitpath[1];
	return {pathname, search};
};

export const getPathNameAndSearch = () => {
	// Get redirect link
	let pathname = getRedirectLink(window.location.search);
	let search = null;
	if (pathname.includes('?')) {
		const splittedUrl = splitUrl(pathname);
		pathname = splittedUrl.pathname;
		search = splittedUrl.search;
	}
	return {pathname, search};
};
